import axios from 'axios';
import { req,reqObj,getReq,getReqObj } from './axiosFun';


export const addRule = (params) => { return reqObj("/api/split_account_rule/addRule", params) };

export const get_split_rule_page = (params) => { return req('get',"/api/split_account_rule/get_split_rule_page", params) };

export const editRule = (params) => { return reqObj("/api/split_account_rule/editRule", params) };

export const delRule = (params) => { return reqObj("/api/split_account_rule/delRule", params) };

export const approve_rule = (params) => { return req('get', "/api/split_account_rule/approve_rule", params) };

export const fileOnload = (params) => { return req("post", "/api/yinLian/fileOnload", params,true) };

export const add_split_rule_account = (params) => { return reqObj("/api/split_rule_account_info/add_split_rule_account", params) };

export const get_split_account = (params) => { return getReq("/api/split_rule_account_info/get_split_account", params) };

export const del_split_account_detail = (params) => { return getReq("/api/split_rule_account_info/del_split_account_detail", params) };


export const get_split_account_detail = (params) => { return getReq("/api/split_rule_account_info/get_split_account_detail", params) };

export const eidt_split_rule_account = (params) => { return reqObj("/api/split_rule_account_info/eidt_split_rule_account", params) };

export const messageConfirmation = (params) => { return reqObj("/api/yinLian/messageConfirmation", params) };

export const messageResend = (params) => { return reqObj("/api/yinLian/messageResend", params) };

export const findSubAccountList = (params) => { return req('get',"/api/yinLian/findSubAccountList", params) };

export const findClearingTheQuery = (params) => { return reqObj("/api/yinLian/findClearingTheQuery", params) };

export const findRowPayQueryList = (params) => { return req('get',"/api/yinLian/findRowPayQueryList", params) };

export const findRowForDetails = (params) => { return req('get',"/api/yinLian/findRowForDetails", params) };



// WEBPACK FOOTER //
// ./src/api/bankMG.js